/**
 * Directive: metaBlock
 */
angular.module('acme.common.directive.metaBlock', [])
.directive('metaBlock', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/metaBlock/metaBlock.tpl.html',
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.metaBlock = "Your spankin new metaBlock!";

      }]

    };

}]);